import { ReactElement } from "react";
import { Button, Typography } from "@altimateai/lego";
import { Link } from "react-router-dom";
import { Stack } from "@altimateai/lego";

export function ResourceNotFound({ variant }: { variant: "user" | "dashboard" }): ReactElement {
  const resourceLabel = variant === "user" ? "User" : "Dashboard";
  return (
    <div className="al-py-[50px] al-rounded al-bg-background al-text-center">
      <Stack className="al-pt-4" align={"center"} direction={"column"} justify="center">
        <Typography variant="h3" className="al-text-muted-foreground">
          {resourceLabel} not found
        </Typography>
        <Typography variant="body" className="al-mb-4 al-mt-2 al-text-muted-foreground">
          The {variant} you are looking for does not exist. Please check the URL and try again.
        </Typography>
        <Button asChild>
          <Link to={variant === "dashboard" ? "/bi-reports/dashboards" : "/bi-reports/users"}>
            Back to {resourceLabel} Listing
          </Link>
        </Button>
      </Stack>
    </div>
  );
}
